var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7728 8.39385L15.0417 7.12494C15.1987 6.96789 15.2773 6.88936 15.3372 6.81696C15.9497 6.07704 15.9497 5.00618 15.3372 4.26626C15.2773 4.19386 15.1987 4.11533 15.0417 3.95828L15.0416 3.95824L15.0416 3.95823C14.8846 3.8012 14.8061 3.72269 14.7337 3.66276C13.9938 3.05024 12.9229 3.05024 12.183 3.66276C12.1106 3.72269 12.0321 3.80122 11.875 3.95827L10.5877 5.2456C11.3428 6.55829 12.4422 7.64914 13.7728 8.39385ZM9.13305 6.70025L4.02306 11.8102L4.02305 11.8102C3.598 12.2353 3.38547 12.4478 3.24574 12.7089C3.106 12.97 3.04706 13.2647 2.92917 13.8542L2.5221 15.8895C2.45558 16.2221 2.42232 16.3884 2.51693 16.483C2.61154 16.5776 2.77784 16.5444 3.11045 16.4779L5.14577 16.0708C5.73522 15.9529 6.02994 15.894 6.29104 15.7542C6.55214 15.6145 6.76467 15.402 7.18973 14.9769L12.3144 9.85227C11.035 9.04277 9.95016 7.9653 9.13305 6.70025Z",
    fill: "#273B4A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFill);
export default __webpack_public_path__ + "static/media/Edit_fill.1aefdb135f7950987d032d3a9bca4f20.svg";
export { ForwardRef as ReactComponent };